export default function WhoIsFor() {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            適合什麼樣的公司？
          </h2>
          <div className="w-20 h-1 bg-teal-500 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-8 border border-gray-200 hover:border-teal-300 transition-colors">
            <div className="w-14 h-14 bg-teal-100 rounded-full flex items-center justify-center mb-5">
              <i className="ri-time-line text-2xl text-teal-600"></i>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-3">
              希望網站能長期穩定使用的公司
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              需要一個可以持續運作、長期使用的網站，而非一次性的交付專案
            </p>
          </div>

          <div className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-8 border border-gray-200 hover:border-teal-300 transition-colors">
            <div className="w-14 h-14 bg-teal-100 rounded-full flex items-center justify-center mb-5">
              <i className="ri-repeat-line text-2xl text-teal-600"></i>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-3">
              不想每次修改都重新找廠商
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              希望有固定的服務窗口，不需要每次有需求都重新尋找協助
            </p>
          </div>

          <div className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-8 border border-gray-200 hover:border-teal-300 transition-colors">
            <div className="w-14 h-14 bg-teal-100 rounded-full flex items-center justify-center mb-5">
              <i className="ri-team-line text-2xl text-teal-600"></i>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-3">
              沒有內部技術人員處理網站
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              公司內部沒有專門的技術人員，需要外部專業團隊協助維護
            </p>
          </div>

          <div className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-8 border border-gray-200 hover:border-teal-300 transition-colors">
            <div className="w-14 h-14 bg-teal-100 rounded-full flex items-center justify-center mb-5">
              <i className="ri-shield-user-line text-2xl text-teal-600"></i>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-3">
              希望有人對網站「負責到底」
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              重視責任歸屬，希望有明確的服務方負責網站的所有相關事項
            </p>
          </div>
        </div>

        <div className="mt-12 bg-gradient-to-br from-teal-50 to-white rounded-2xl p-8 border border-teal-100">
          <div className="flex items-start">
            <i className="ri-lightbulb-line text-teal-600 text-2xl mr-4 mt-1 flex-shrink-0"></i>
            <div>
              <h4 className="text-lg font-semibold text-gray-900 mb-2">關鍵思考點</h4>
              <p className="text-base text-gray-700 leading-relaxed">
                如果您希望網站是一個持續運作的工具，而非一次性的交付成果，年度管理方案能確保有人長期負責處理所有網站相關事項。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
